// import React, { memo, useEffect } from "react";
// import CustomButton from "./CustomButton";
// import { TfiAngleLeft, TfiAngleRight } from "react-icons/tfi";

// interface CustomPaginationProps {
//   page: number;
//   totalPages: number;
//   setPage: (page: number) => void;
// }

// const CustomPagination: React.FC<CustomPaginationProps> = ({
//   page,
//   totalPages,
//   setPage,
// }) => {
//   const handleBackButtonClick = () => {
//     if (page > 1) {
//       setPage(page - 1);
//     }
//   };

//   const handleNextButtonClick = () => {
//     if (page < totalPages) {
//       setPage(page + 1);
//     }
//   };

//   const handlePageClick = (newPage: number) => {
//     setPage(newPage);
//   };

//   return (
//     <div className="flex gap-3 items-center justify-center mt-4">
//       {/* <div>
//         show pages {page} - {totalPages}
//       </div> */}
//       <div className="flex gap-3 items-center justify-between">
//         <CustomButton
//           //   disabled={page <= 1}
//           icon={<TfiAngleLeft />}
//           bg={page <= 1 ? "bg-white" : undefined}
//           textColor={page <= 1 ? "text-darkCyan" : undefined}
//           border={page <= 1 ? "border border-darkCyan" : undefined}
//           padding="0"
//           rounded="rounded-lg"
//           addclass="w-9 h-9"
//           handleClick={handleBackButtonClick}
//         />

//         <div
//           className={`w-9 h-9 flex justify-center items-center ${
//             page === page
//               ? "bg-customBlue bg-darkCyan text-white"
//               : "bg-gray-300 text-white"
//           } rounded-lg cursor-pointer`}
//           onClick={() => handlePageClick(page)}
//         >
//           {page}
//         </div>

//         {page < totalPages && (
//           <div
//             className="w-9 h-9 flex justify-center items-center text-darkCyan border-darkCyan border rounded-lg cursor-pointer"
//             onClick={() => handlePageClick(page + 1)}
//           >
//             {page + 1}
//           </div>
//         )}

//         <CustomButton
//           //   disabled={page >= totalPages}
//           rounded="rounded-lg"
//           padding="0"
//           addclass="w-9 h-9"
//           textColor={page >= totalPages ? "text-darkCyan" : undefined}
//           icon={<TfiAngleRight />}
//           border={page >= totalPages ? "border border-darkCyan" : undefined}
//           bg={page >= totalPages ? "bg-white" : undefined}
//           handleClick={handleNextButtonClick}
//         />
//       </div>
//     </div>
//   );
// };

// export default memo(CustomPagination);

import React, { memo } from "react";
import CustomButton from "./CustomButton";
import {
  TfiAngleDoubleLeft,
  TfiAngleDoubleRight,
  TfiAngleLeft,
  TfiAngleRight,
} from "react-icons/tfi";

interface CustomPaginationProps {
  page: number;
  totalPages: number;
  setPage: (page: number) => void;
}

const CustomPagination: React.FC<CustomPaginationProps> = ({
  page,
  totalPages,
  setPage,
}) => {
  const handleBackButtonClick = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleNextButtonClick = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  const handlePageClick = (newPage: number) => {
    if (newPage !== page) {
      setPage(newPage);
    }
  };
  const handleFirstPageClick = () => {
    setPage(1);
  };

  const handleLastPageClick = () => {
    setPage(totalPages);
  };
  // Function to dynamically show a range of page numbers
  const getPageNumbers = () => {
    const visiblePages = 5; // Number of pages to display at once
    let startPage = Math.max(1, page - Math.floor(visiblePages / 2));
    let endPage = Math.min(totalPages, startPage + visiblePages - 1);

    if (endPage - startPage < visiblePages - 1) {
      startPage = Math.max(1, endPage - visiblePages + 1);
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index
    );
  };

  return (
    <div className="flex gap-3 items-center justify-center mt-4">
      <CustomButton
        btntext={<TfiAngleDoubleLeft />}
        bg={page <= 1 ? "bg-gray-300" : "bg-white"}
        textColor={page <= 1 ? "text-black" : "text-black"}
        border={page <= 1 ? "border" : ""}
        padding="0"
        rounded="rounded-lg"
        addclass="w-9 h-9"
        handleClick={handleFirstPageClick}
      />
      <CustomButton
        icon={<TfiAngleLeft />}
        bg={page <= 1 ? "bg-white" : undefined}
        textColor={page <= 1 ? "text-darkCyan" : undefined}
        border={
          page <= 1 ? "border border-darkCyan cursor-not-allowed	" : undefined
        }
        padding="0"
        rounded="rounded-lg"
        addclass="w-9 h-9"
        handleClick={handleBackButtonClick}
      />

      {/* Dynamically render page numbers */}
      {getPageNumbers().map((pageNum) => (
        <div
          key={pageNum}
          className={`w-9 h-9 flex justify-center items-center ${
            page === pageNum
              ? "bg-darkCyan text-white"
              : "bg-gray-100 border border-darkCyan text-darkCyan"
          } rounded-lg cursor-pointer`}
          onClick={() => handlePageClick(pageNum)}
        >
          {pageNum}
        </div>
      ))}

      <CustomButton
        rounded="rounded-lg"
        padding="0"
        addclass="w-9 h-9"
        textColor={page >= totalPages ? "text-darkCyan" : undefined}
        icon={<TfiAngleRight />}
        border={page >= totalPages ? "border border-darkCyan" : undefined}
        bg={page >= totalPages ? "bg-white cursor-not-allowed	" : undefined}
        handleClick={handleNextButtonClick}
      />
      <CustomButton
        rounded="rounded-lg"
        padding="0"
        addclass="w-9 h-9"
        textColor={page >= totalPages ? "text-black" : ""}
        btntext={<TfiAngleDoubleRight />}
        border={page >= totalPages ? "border" : ""}
        bg={page >= totalPages ? "bg-gray-300" : "bg-white"}
        handleClick={handleLastPageClick}
      />
    </div>
  );
};

export default memo(CustomPagination);
